import { action } from '@ember/object';
import SettingsGroupsBaseController from '../base';
import GroupModel from 'scaleflow/models/group';

export default class SettingsGroupsListCreateController extends SettingsGroupsBaseController {
  declare model: GroupModel;

  @action
  cancel() {
    // Delete the record instead of just rolling back
    void this.model.destroyRecord();
    this.goToListPage();
  }
}
